export type QuestionResult = 'YES' | 'NO' | 'CANCEL';
